import ApplicationSerializer from './application';

export default class ProspectiveClient extends ApplicationSerializer {
  serialize(snapshot, options) {
    let json = super.serialize(snapshot, options);

    const clientRelationshipsAttributes = snapshot.record.get('clientRelationshipsAttributes');

    if (clientRelationshipsAttributes?.length) {
      if (!json.data.attributes) {
        json.data.attributes = {};
      }
      json.data.attributes.clientRelationshipsAttributes = clientRelationshipsAttributes;
    }

    return json;
  }
}
